import { bookingServiceSagas } from 'features/Booking/services/sagas';
import { all } from 'redux-saga/effects';
export default function* rootSaga() {
  yield all([
    // define module saga here
    bookingServiceSagas(),
  ]);
}
